import { IonInput } from "@ionic/react";
import React from "react";
import { withTranslation } from "react-i18next";

class PasswordNew extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      showUi: false,
      fileName: "",
    };
  }

  render() {
    const { type, placeholder, t, ...mainFieldProps } = this.props;
    const { name, value, onIonChange, onIonChangeSupporting, ...supportingFieldProps } = mainFieldProps;
    const newType = "password";

    return (
      <>
        {!this.props.disabled && <IonInput name="password_current" placeholder={t("currentPassword")} type={newType} onIonChange={onIonChangeSupporting} {...supportingFieldProps} />}
        <IonInput placeholder={this.props.disabled ? "********" : t("newPassword")} type={newType} {...mainFieldProps} />
        {!this.props.disabled && <IonInput name="password_confirmation" placeholder={t("confirmNewPassword")} type={newType} onIonChange={onIonChangeSupporting} {...supportingFieldProps} />}
      </>
    );
  }
}

export default withTranslation()(PasswordNew);
